// @flow
import React, { Fragment } from 'react';
import FocusedImage from 'Components/FocusedImage';
import AssetModel from 'Stores/AssetModel';
import styles from './styles.scss';

type Props = {
  url?: any,
  previewUrl?: any,
  focus?: any,
  title?: string,
  description?: string,
  detailView?: boolean,
  onClick?: (index: number) => void,
  index: number,
  imagesLength: number,
};

export default class GalleryImage extends React.Component<Props> {
  static defaultProps = {
    onClick: () => {},
  };

  onClick = () => {
    this.props.onClick && this.props.onClick(this.props.index);
  };

  render() {
    const { url, previewUrl, focus, title, description, detailView, index, imagesLength } =
      this.props;

    return (
      <Fragment>
        {detailView && (
          <div className={styles.imageWrapper}>
            <div className={styles.image}>
              <div className={styles.imageEl}>
                <img src={url} alt={title || ''} className={styles.gimage} />
              </div>
              <div className={styles.details}>
                <div className={styles.title}>{title}</div>
                {description}
              </div>
            </div>
          </div>
        )}
        {!detailView && (
          <div className={styles.wrapper} onClick={this.onClick}>
            <div className={styles.image}>
              {index === 5 && <div className={styles.more}>+{imagesLength - 5}</div>}
              {index === 8 && <div className={styles.more}>+{imagesLength - 8}</div>}
              <FocusedImage image={new AssetModel({ src: previewUrl, focus })} />
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}
